export const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
};
